// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1Fzdi","productName":"Table_productName__1BEjV"};